import { WEBBACK_V2_API } from "@constants"

// The two branches of the form: which reference price a customer's discounts are computed
// against. Local state — the mode is a UI choice, not a stored field.
export const PRICING_CONFIG_MODES = {
    RETAILER: 'retailer',
    RRSP: 'rrsp'
}

export const PRICING_CONFIG_MODE_OPTIONS = [
    { value: PRICING_CONFIG_MODES.RETAILER, label: 'Reference retailer' },
    { value: PRICING_CONFIG_MODES.RRSP, label: 'RRSP' }
]

// What the `/setup` endpoint answers (derived from `DIPI_USER.role`) → the mode of this form.
export const MODE_BY_SETUP = {
    main_site: PRICING_CONFIG_MODES.RETAILER,
    rrsp: PRICING_CONFIG_MODES.RRSP
}

// `DIPI_CUSTOMER_FEATURES.use_rrsp = 0` means the customer does **not** use the RRSP: v1 drops the
// RRSP columns from its exports. NULL is not the same as 0 — v1's fallback for a missing row is 1
// (`app/database/customer_features/dao.py:17`), so only an explicit zero disables the branch.
export const RRSP_DISABLED = 0

// `DIPI_USER.role` — the column that actually decides which reference price a user reads.
export const ROLE_BY_MODE = {
    [PRICING_CONFIG_MODES.RETAILER]: 'retailerUser',
    [PRICING_CONFIG_MODES.RRSP]: 'user'
}

// What the user ends up seeing in Pricing and Stock, per mode. Used in the warning copy.
export const PRICE_COLUMN_BY_MODE = {
    [PRICING_CONFIG_MODES.RETAILER]: 'My Current Price',
    [PRICING_CONFIG_MODES.RRSP]: 'RRSP'
}

// Read endpoints live in dipi-webback-v2 (`app/domains/admin/pricing_config/`): they answer for
// the *selected* customer, which v1's own option APIs cannot do — they scope by the session user.
export const PRICING_CONFIG_APIS = {
    SETUP: `${WEBBACK_V2_API}/admin/pricing-config/setup`,
    SAVE: `${WEBBACK_V2_API}/admin/pricing-config/save`,
    MAIN_SITES: `${WEBBACK_V2_API}/admin/pricing-config/main-sites`,
    RRSP: `${WEBBACK_V2_API}/admin/pricing-config/rrsp`,
    SKU_OPTIONS: `${WEBBACK_V2_API}/admin/pricing-config/sku-options`
}

// `RRSP.market` is varchar(2), while `DIPI_CUSTOMER_MAIN_SITE.country` is varchar(10) and holds
// values like `ES_CA`. So a market the retailer branch accepts does not fit in the RRSP table:
// the RRSP branch has to reject anything longer than this, or the insert truncates.
export const RRSP_MARKET_MAX_LENGTH = 2

// No currency catalogue exists in the app or in v1's APIs, and `RRSP.currency` is a free
// varchar(3). This is the set actually seen across the site master.
export const CURRENCY_OPTIONS = [
    'EUR', 'GBP', 'USD', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'CZK', 'HUF', 'RON', 'MXN', 'BRL',
    'CAD', 'AUD'
].map(currency => ({ value: currency, label: currency }))
